/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAuthorizedSignerName_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null };

export type GetAuthorizedSignerName_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly authorizedSigner: GetAuthorizedSignerName_creditApplication_CreditApplication_authorizedSigner_CreditApplicationPerson | null };

export type GetAuthorizedSignerName_Query = { readonly __typename: 'Query', readonly creditApplication: GetAuthorizedSignerName_creditApplication_CreditApplication | null };


export type GetAuthorizedSignerNameVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetAuthorizedSignerName = GetAuthorizedSignerName_Query;


export const GetAuthorizedSignerNameDocument = gql`
    query GetAuthorizedSignerName($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    authorizedSigner {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetAuthorizedSignerName__
 *
 * To run a query within a React component, call `useGetAuthorizedSignerName` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorizedSignerName` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorizedSignerName({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetAuthorizedSignerName(baseOptions: Apollo.QueryHookOptions<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables> & ({ variables: GetAuthorizedSignerNameVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>(GetAuthorizedSignerNameDocument, options);
      }
export function useGetAuthorizedSignerNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>(GetAuthorizedSignerNameDocument, options);
        }
export function useGetAuthorizedSignerNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>(GetAuthorizedSignerNameDocument, options);
        }
export type GetAuthorizedSignerNameHookResult = ReturnType<typeof useGetAuthorizedSignerName>;
export type GetAuthorizedSignerNameLazyQueryHookResult = ReturnType<typeof useGetAuthorizedSignerNameLazyQuery>;
export type GetAuthorizedSignerNameSuspenseQueryHookResult = ReturnType<typeof useGetAuthorizedSignerNameSuspenseQuery>;
export type GetAuthorizedSignerNameQueryResult = Apollo.QueryResult<GetAuthorizedSignerName, GetAuthorizedSignerNameVariables>;